/**
 * @file Provider: ButtonSoundProvider
 * @description A provider component that adds sound effects to all button elements
 */

import type React from 'react';
import { useEffect } from 'react';
import {
  initButtonSoundManager,
  useGlobalButtonSounds,
} from '../../utils/buttonSoundManager';

interface ButtonSoundProviderProps {
  children: React.ReactNode;
}

/**
 * Provider component that adds sound effects to all button elements in the application
 * This should be placed high in the component tree, typically near the root
 */
const ButtonSoundProvider: React.FC<ButtonSoundProviderProps> = ({
  children,
}) => {
  // Initialize the button sound manager once when the component mounts
  useEffect(() => {
    initButtonSoundManager();
  }, []);

  // Use the global button sounds hook
  useGlobalButtonSounds();

  // Simply render the children
  return <>{children}</>;
};

export default ButtonSoundProvider;
